<span class="close" (click)="doCloseDialog()">x</span>
<app-write-a-review [itemId]="itemId" [orderId]="orderId"></app-write-a-review>
